import { useState } from 'react';
import { BundleStore, useBundleStore } from '../hooks/bundle-store';
import { useShallow } from 'zustand/react/shallow';

export default function RotationButton() {
  const [isActive, setIsActive] = useState(false);

  const { isSceneRotationEnabled, setIsSceneRotationEnabled, isApparel, enableZoom } =
    useBundleStore(
      useShallow((state: BundleStore) => ({
        isSceneRotationEnabled: state?.isSceneRotationEnabled,
        setIsSceneRotationEnabled: state?.setIsSceneRotationEnabled,
        isApparel: state.bundle?.isApparel,
        enableZoom: state.enableZoom,
      })),
    );

  const handleToggleRotationAnimation = () => {
    setIsSceneRotationEnabled(!isSceneRotationEnabled);
  };
  return (
    isApparel && (
      <div
        style={{
          position: 'absolute',
          bottom: 10,
          left: !enableZoom ? 60 : 10,
        }}>
        <div
          style={{
            width: '32px',
            height: '32px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
            borderRadius: '50%',
            border: '2px solid white',
            color: 'black',
            cursor: 'pointer',
            fontSize: '12px',
            padding: '4px',
            boxShadow: isActive ? '0 0 5px rgba(0, 0, 0, 0.15)' : 'none',
            transition: 'all 0.2s ease-in-out',
          }}
          onMouseDown={() => setIsActive(true)}
          onMouseUp={() => setIsActive(false)}
          onMouseLeave={() => setIsActive(false)}
          onClick={handleToggleRotationAnimation}
          title="Reset 3D">
          {isSceneRotationEnabled ? (
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.2999 4.80078C9.79696 4.80078 10.1999 5.20372 10.1999 5.70078V18.3008C10.1999 18.7978 9.79696 19.2008 9.2999 19.2008C8.80285 19.2008 8.3999 18.7978 8.3999 18.3008V5.70078C8.3999 5.20372 8.80285 4.80078 9.2999 4.80078ZM14.6999 4.80078C15.197 4.80078 15.5999 5.20372 15.5999 5.70078V18.3008C15.5999 18.7978 15.197 19.2008 14.6999 19.2008C14.2028 19.2008 13.7999 18.7978 13.7999 18.3008V5.70078C13.7999 5.20372 14.2028 4.80078 14.6999 4.80078Z"
                fill="var(--primary-color)"
              />
            </svg>
          ) : (
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.47291 3.7074C6.76421 3.55036 7.11819 3.56585 7.39465 3.74774L18.7947 11.2477C19.0477 11.4142 19.2 11.6967 19.2 11.9996C19.2 12.3025 19.0477 12.585 18.7947 12.7515L7.39465 20.2515C7.11819 20.4334 6.76421 20.4489 6.47291 20.2918C6.18161 20.1348 6 19.8305 6 19.4996V4.49961C6 4.16868 6.18161 3.86444 6.47291 3.7074ZM7.8 6.16902V17.8302L16.6625 11.9996L7.8 6.16902Z"
                fill="var(--primary-color)"
              />
            </svg>
          )}
        </div>
      </div>
    )
  );
}
